// A tall pole flying a pennant, marking territory. Ported 1:1 from age-of-mcp's
// flag.ts: a pole that grows per stage and a triangular pennant added once it is
// complete, with the shared foundationSlab for the foundation stage.
import * as THREE from "three";
import { defineModel, foundationSlab, type Part } from "../../lib";

const POLE_COLOR = "#6b4a22";
const PENNANT_COLOR = "#c0392b";

// Pole heights per stage.
const POLE_H = [0, 0.2, 0.45, 0.72];

function pole(h: number): Part {
  return {
    geometry: new THREE.CylinderGeometry(0.025, 0.03, h, 6),
    color: POLE_COLOR,
    position: [0, h / 2, 0],
  };
}

// A flat rectangular pennant flying off the top of the pole.
function pennant(poleH: number): Part {
  const pw = 0.22;
  const ph = 0.12;
  return {
    geometry: new THREE.BoxGeometry(pw, ph, 0.015),
    color: PENNANT_COLOR,
    position: [pw / 2 + 0.025, poleH - ph / 2 - 0.01, 0],
  };
}

function partsFor(s: number): Part[] {
  if (s <= 0) return [foundationSlab(0.14, 0.04)];
  const h = POLE_H[Math.min(s, 3)]!;
  const parts: Part[] = [pole(h)];
  if (s >= 3) parts.push(pennant(h));
  return parts;
}

export const flag = defineModel({
  id: "flag",
  tiles: { w: 1, h: 1 },
  batchId: "standard",
  name: "Flag",
  tags: ["building","flag","low-poly","age-of-mcp","classic"],
  summary: "Low-poly flag.",
  description: "A tall pole flying a pennant, marking territory and inscribed with a short name or message.",
  author: "age-of-mcp",
  footprint: 0.1,
  defaultVariant: "complete",
  variants: [
    { id: "stage-0", label: "Foundation", parts: () => partsFor(0) },
    { id: "stage-1", label: "Lower", parts: () => partsFor(1) },
    { id: "stage-2", label: "Upper", parts: () => partsFor(2) },
    { id: "complete", label: "Complete", parts: () => partsFor(3) },
  ],
  animations: [],
});
